module.exports = __webpack_public_path__ + "static/media/ку.96c1eb12.mp3";